<template>
  <div>
    <h1 class="text-[14px] font-semibold text-[#14171F] mb-4">Enter (beneficial owner’s name) home address</h1>
    <p class="text-[14px] font-normal text-[#14171F] mb-4">Provide the home address where (beneficial owner’s name)
      currently reside, so we are able to verify your address</p>
    
    <div class="mt-4 p-[20px]">
      <div class="flex justify-between items-center mb-4 ">
        <h5 class="text-[#321C3B] text-[600]">{{this.ownerData.fullName}}</h5>
        <button @click.prevent="showInfo" class="pt-2">
          <span v-if="isExpanded">&#710;</span>
          <span v-else>&#711; </span>
        </button>
      </div>
      <div v-if="isExpanded" class=" w-full ">
        <div class="flex flex-wrap gap-6  ">
          <div class="flex-1 ">
            <label for="address" class="label">Address</label>
            <input type="text" class="input" v-model="location.address" placeholder="-- Enter address --" />
          </div>
          <div class="flex-1 ">
            <label for="country" class="label">Country</label>
            <el-select v-model="selectedCountry" value-key="isoCode" placeholder="-- Select Country --">
              <el-option v-for="country in countries" :key="country.isoCode" :label="country.name" :value="country">
              </el-option>
            </el-select>
          </div>
          <div class="flex-1 ">
            <label for="state" class="label">State of Region</label>
            <el-select v-model="selectedState" value-key="isoCode" placeholder="-- Select State --">
              <el-option v-for="state in states" :key="state.isoCode" :label="state.name" :value="state">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="flex flex-wrap gap-6  ">
          <div class="flex-1 ">
            <label for="city" class="label">City</label>
            <el-select v-model="selectedCity" placeholder="-- Select City --">
              <el-option v-for="city in cities" :key="city.name" :label="city.name" :value="city.name">
              </el-option>
            </el-select>
          </div>
          <div class="flex-1 ">
            <label for="zipcode" class="label">Zip or Post Code</label>
            <input type="text" class="input" v-model="kyc.zipCode" placeholder="-- Enter Zip or Post Code --" />
          </div>
          <div class="flex-1 ">
            <label for="apartment" class="label">Apartment/Unit Number</label>
            <input type="text" class="input" v-model="kyc.apartmentNumber"
              placeholder="-- Enter Apartment/Unit Number --" />
          </div>
        </div>
      </div>
    </div>
    <hr>

    <h1 class="text-[14px] font-semibold text-[#14171F] mb-4">Enter (beneficial owner’s name) home address</h1>

    <div class=" py-2 px-4 incorporated  mb-4">
      <p class="text-[14px] font-normal text-[#383F51]">
        Proof of address can be any of the listed documents below,
        not more than 6 months old and in JPG, JPEG, PNG or PDF.</p>
      <hr>
      <ul>
        <li class="text-[14px] font-normal text-[#383F51]">Utility bill for services to the address (e.g electricity,
          water or DSTV bills)</li>
        <li class="text-[14px] font-normal text-[#383F51]">Bank statement showing current address</li>
        <li class="text-[14px] font-normal text-[#383F51]">Tax assessment document showing address</li>
        <li class="text-[14px] font-normal text-[#383F51]">Letter from a public authority</li>
      </ul>
    </div>
   
    <form class="mt-4" @submit.prevent="verify">
      <label for="" class="text-[14px] font-semibold text-[#14171F]">Please upload a proof of address</label>
      <input ref="fileInput" type="file" style="display: none;" accept="image/*" @change="onFileSelected">
      <button v-if="!imageUrl.verify" @click.prevent="selectImage('verify')"
        class="flex justify-between items-center px-4 py-2 w-[220px]">
        <p class="text-[14px] font-normal text-[#7A90A7]">Upload File </p>
        <img src="@/assets/images/ondemand/upload-icon-claim.svg" alt="" srcset="">
      </button>
      <button v-if="imageUrl.verify" class=" flex justify-between items-center px-2 py-2 w-[250px]">
        <img width="" src="@/assets/images/ondemand/uploaded-file-icon.svg" alt="Selected Image" />
        <p class="text-[14px] font-normal text-[#383F51]">{{ kyc.verify }}</p>
        <img @click.prevent="removeImage(imageUrl.verify, 'verify')" src="@/assets/images/ondemand/claim-icon-close.svg"
          alt="" srcset="">
      </button>
      <h1 class="text-[16px] font-normal text-[#14171F] mt-4">Don't have these documents on hand? <span
          @click="togglePOD">Skip and
          upload later</span></h1>
      <div class="next-submit flex justify-end mt-4">
        <button type="submit"
          :class="['py-2 px-4 text-[16px] font-semibold text-[#10233E] transition-all duration-300', buttonClass]">
          Save
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { Country, State, City } from "country-state-city";

export default {
  data() {
    return {
      kyc: {
        zipCode: "",
        apartmentNumber: "",
        verify: null,
      },
      location: {
        address: "",
        country: "",
        state: "",
        city: "",
      },

      countries: [],
      states: [],
      cities: [],
      selectedCountry: null,
      selectedState: null,
      selectedCity: null,
      isExpanded: true,
      showPOD: true,
      fileType: '',
      imageUrl: {
        verify: null,
      },
     
    }
  },
  props: [ 'ownerData'],
  watch: {
    selectedCountry(newVal) {
      if (!newVal) {
        this.states = []
        this.cities = []
        return
      }

      this.states = State.getStatesOfCountry(newVal.isoCode)
      this.location.country = newVal.name
    },

    selectedState(newVal) {
      if (!newVal) {
        this.cities = []
        this.selectedCity = null
        return
      }
      this.cities = City.getCitiesOfState(
        this.selectedCountry.isoCode,
        newVal.isoCode
      )
      // Save actual name
      this.location.state = newVal.name
    },
    selectedCity(newVal) {
      if (!newVal) return
      this.location.city = newVal
    },
  },

  mounted() {
    this.countries = Country.getAllCountries();
    this.selectedCountry = this.countries.find(
      c => c.name === this.location.country
    );

    // ✅ STEP 2: Load states immediately
    if (this.selectedCountry) {
      this.states = State.getStatesOfCountry(this.selectedCountry.isoCode);

      // ✅ STEP 3: Set selectedState properly
      this.selectedState = this.states.find(
        s => s.name === this.location.state
      );
    }
    // ✅ STEP 4: Load cities immediately
    if (this.selectedCountry && this.selectedState) {
      this.cities = City.getCitiesOfState(
        this.selectedCountry.isoCode,
        this.selectedState.isoCode
      );

      // ✅ STEP 5: Set selectedCity
      this.selectedCity = this.location.city;
    }
  },

  computed: {
    buttonClass() {
      return this.isFormValid
        ? 'opacity-100 cursor-pointer hover:scale-105'
        : 'opacity-50 cursor-not-allowed';
    },
    isFormValid() {
      return (
         this.kyc.apartmentNumber.trim() &&
        this.kyc.zipCode.trim() &&
        this.selectedCountry &&
        this.selectedState &&
        this.selectedCity 
        // this.imageUrl.verify ||
        // !this.showPOD
      );
    }
  },

  methods: {
    
    showInfo() {
      this.isExpanded = !this.isExpanded
    },

    togglePOD() {
      this.showPOD = false;
    },

    verify() {
      if (this.isFormValid) {

        this.$emit('saveAddress', {
                    ...this.kyc,
                    address: this.location.address,
                    country: this.location.country,
                    state: this.location.state,
                    city: this.location.city,
                    imageUrl: this.imageUrl.verify,
                    showPOD: this.showPOD
                });

      } else {
        this.generateToast("Form is invalid, cannot proceed.", "error");
      }
    },

    selectImage(fileType) {
      this.$refs.fileInput.click();
      this.fileType = fileType
    },
    onFileSelected(event) {
      const file = event.target.files[0];
      if (file.size > 1048576) {
        this.generateToast("Selected image size is too large. Please upload an image smaller than 1MB!", "error");
        return;
      }

      if (this.fileType === 'verify' && file && file.type.startsWith('image/')) {
        this.kyc.verify = file.name;
        this.uploadImage(file, 'verify');
        this.$forceUpdate();
      } else {
        this.generateToast("Please select a valid image file!", "error");
        this.imageUrl = null;
      }

    },
    async uploadImage(image, type) {
      this.isUploadingImage = true;

      const formData = new FormData();
      formData.append("file", image);
      formData.append("upload_preset", "zunt8yrw");

      try {
        const response = await this.$_uploadImage(formData);
        const imageUrl = response?.data?.fileUrl;

        if (!imageUrl) throw new Error("Upload failed: no URL returned");
        if (type === 'verify' && imageUrl) {
          this.imageUrl.verify = imageUrl;
          this.generateToast("Image uploaded", "success");
        }
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isUploadingImage = false;
      }
    },
    removeImage(file, fileType) {
      this.fileType = fileType
      if (file === this.imageUrl.verify && this.fileType === 'verify') {
        this.imageUrl.verify = null
        this.$refs.fileInput.value = '';
        this.$forceUpdate();
      }
    },
  }
}

</script>

<style scoped>
hr {
  border: 1px solid #C2C7D6;
  margin: 16px auto;
}

.incorporated {
  border-radius: 8px;
  background-color: #F2F7FC;
}

ul {
  list-style-type: disc;
  padding-left: 20px;
}

ul>li {
  margin-bottom: 8px;
}

h1>span {
  color: #09B78A;
  cursor: pointer;
}

form>button {
  border: 1px solid #C2C7D6;
  border-radius: 124px;
  background-color: transparent;
  cursor: pointer;
}

button>span {
  font-size: 35px;
}

.next-submit>button {
  background-color: #FCC210;
  border-radius: 2px;
  /* opacity: 0.5;
    cursor: not-allowed; */
}
</style>
